import { useSyncExternalStore } from "react";
import APP_VERSION from "../version";
import { getMajorMinor, isNewerMajorMinor } from "./versionUtils";

// Header the API puts on every response (see AppVersion.php / index.php).
const HEADER = "X-Ezentry-Version";

let serverVersion = null;
const listeners = new Set();

/** Call with every API response; remembers the server's version. */
export function reportServerVersion(response) {
  const v = response?.headers?.get?.(HEADER);
  if (!v || v === serverVersion) return;
  serverVersion = v;
  listeners.forEach((l) => l());
}

const subscribe = (l) => {
  listeners.add(l);
  return () => listeners.delete(l);
};

/** Latest backend version seen, or null before the first API response. */
export function useServerVersion() {
  return useSyncExternalStore(subscribe, () => serverVersion);
}

/**
 * True when the server's major.minor is newer than this bundle — a reload helps.
 * (A server that is *older* than the bundle is not fixable by reloading, and
 * patch releases are ignored on purpose, same as What's New.)
 */
export function isServerNewer(server, app = APP_VERSION) {
  if (!server) return false;
  return isNewerMajorMinor(getMajorMinor(server), getMajorMinor(app));
}
